import { render, staticRenderFns } from "./ModalNewContract.vue?vue&type=template&id=8de128ec&scoped=true&"
import script from "./ModalNewContract.vue?vue&type=script&lang=ts&"
export * from "./ModalNewContract.vue?vue&type=script&lang=ts&"
import style0 from "./ModalNewContract.vue?vue&type=style&index=0&id=8de128ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de128ec",
  null
  
)

export default component.exports